<template>
  <div style="margin-bottom:10px; margin-top:10px">
    <a-alert type="success"  banner closable>
      <p slot="message">
        <slot name="message"></slot>
      </p>
    </a-alert>
  </div>
</template>

<script>
export default {
  props: {
    messages: String
  }
};
</script>
